import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68efcc0e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68efcc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68efcc0e')) {
      api.createRecord('68efcc0e', component.options)
    } else {
      api.reload('68efcc0e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68efcc0e&scoped=true", function () {
      api.rerender('68efcc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/goods/index.vue"
export default component.exports